import { FC, useState } from "react"
import { FaSave, FaTimes } from "react-icons/fa"
import { toast } from "react-toastify"

import { TournamentService } from "services/tournaments/tournament.service"

import { PointRule } from "types/tournament.types"

import { PointRulesBuilder } from "./point-rules/PointRulesBuilder"

interface PresetCreateFormProps {
  onCreated: () => void
  onCancel: () => void
}

export const PresetCreateForm: FC<PresetCreateFormProps> = ({ onCreated, onCancel }) => {
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [rules, setRules] = useState<PointRule[]>([])

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.error("Preset name is required")
      return
    }
    if (rules.length === 0) {
      toast.error("Add at least one rule before saving")
      return
    }

    try {
      await TournamentService.createPreset({
        name: name.trim(),
        description: description.trim() || undefined,
        rules
      })
      toast.success("Preset created!")
      onCreated()
    } catch {
      // silent
    }
  }

  return (
    <div className="p-6 bg-white dark:bg-[#0C0C1A] rounded-xl border border-[rgba(139,92,246,0.3)] shadow-sm space-y-4">
      <h4 className="text-md font-semibold text-gray-900 dark:text-white">Create New Preset</h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Name *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 border border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)] rounded-lg dark:bg-[rgba(0,0,0,0.2)] dark:text-white focus:border-[rgba(139,92,246,0.5)] focus:outline-none transition-all"
            placeholder="e.g., Standard Slot Rules"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Description</label>
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full px-4 py-2 border border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)] rounded-lg dark:bg-[rgba(0,0,0,0.2)] dark:text-white focus:border-[rgba(139,92,246,0.5)] focus:outline-none transition-all"
            placeholder="Optional description..."
          />
        </div>
      </div>

      <PointRulesBuilder value={rules} onChange={setRules} />

      <div className="flex justify-end gap-3 pt-2">
        <button
          onClick={onCancel}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-all text-sm"
        >
          <FaTimes /> Cancel
        </button>
        <button
          onClick={handleCreate}
          className="flex items-center gap-2 px-4 py-2 bg-[rgba(139,92,246,1)] text-white rounded-lg hover:bg-[rgba(139,92,246,0.8)] transition-all text-sm"
        >
          <FaSave /> Save Preset
        </button>
      </div>
    </div>
  )
}
